import { jsx as _jsx } from "react/jsx-runtime";
function SvgComponent() {
    return (_jsx("svg", { fill: "none", stroke: "currentColor", strokeWidth: 2, viewBox: "0 0 24 24", strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("path", { d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" }) }));
}
export default SvgComponent;
